class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.addHoverBehavior();
  }

  addHoverBehavior() {
    // Desktop-only, mouse-only hover-to-open (2026-08-23). Bound on the
    // custom element itself, which contains both the summary and the
    // submenu as descendants, so a single mouseleave covers "cursor left
    // both the trigger and the dropdown" — the brief gap between them is
    // absorbed by the close delay below, which mouseenter cancels if the
    // cursor lands back inside before it fires. Click-to-toggle (native
    // <details> behavior) and keyboard/focusout handling are untouched.
    const isDesktopHover = () =>
      window.matchMedia('(min-width: 990px)').matches &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    let closeTimer;

    this.addEventListener('mouseenter', () => {
      if (!isDesktopHover()) return;
      clearTimeout(closeTimer);
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
      }
    });

    this.addEventListener('mouseleave', () => {
      if (!isDesktopHover()) return;
      closeTimer = setTimeout(() => this.close(), 150);
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
